(function () {
  function buildTabs(container) {
    var rte = container.querySelector('.rte, .element-text--rte');
    if (!rte || rte.dataset.tabsBuilt) return;

    var detailsEls = rte.querySelectorAll(':scope > details');
    if (!detailsEls.length) return;

    rte.dataset.tabsBuilt = 'true';

    var descWrapper = document.createElement('div');
    var node = rte.firstChild;
    while (node && !(node.nodeType === 1 && node.tagName === 'DETAILS')) {
      var next = node.nextSibling;
      descWrapper.appendChild(node);
      node = next;
    }

    var tabsData = [];
    if (descWrapper.textContent.trim().length) {
      tabsData.push({ label: (window.pdpTabsLabels && window.pdpTabsLabels.description) || 'Description', node: descWrapper });
    }

    detailsEls.forEach(function (d) {
      var summary = d.querySelector('summary');
      var label = summary ? summary.textContent.trim() : 'More';
      var panelNode = document.createElement('div');
      Array.prototype.forEach.call(d.childNodes, function (child) {
        if (child.nodeName !== 'SUMMARY') panelNode.appendChild(child.cloneNode(true));
      });
      tabsData.push({ label: label, node: panelNode });
    });

    rte.innerHTML = '';
    rte.classList.add('pdp-tabs');

    var tabList = document.createElement('div');
    tabList.className = 'pdp-tabs__list';
    tabList.setAttribute('role', 'tablist');

    var panelWrap = document.createElement('div');
    panelWrap.className = 'pdp-tabs__panels';

    tabsData.forEach(function (tab, i) {
      var panel = document.createElement('div');
      panel.className = 'pdp-tabs__panel' + (i === 0 ? ' is-active' : '');
      panel.setAttribute('role', 'tabpanel');
      panel.appendChild(tab.node);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-tabs__tab' + (i === 0 ? ' is-active' : '');
      btn.textContent = tab.label;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.addEventListener('click', function () {
        tabList.querySelectorAll('.pdp-tabs__tab').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panelWrap.querySelectorAll('.pdp-tabs__panel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        panel.classList.add('is-active');
      });

      tabList.appendChild(btn);
      panelWrap.appendChild(panel);
    });

    rte.appendChild(tabList);
    rte.appendChild(panelWrap);
  }

  function init() {
    document.querySelectorAll('.pdp-description-tabs').forEach(buildTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
